import { useCallback, useState } from 'react'
import PropTypes from 'prop-types'

import { Button } from '@material-ui/core'
import fileDownload from 'js-file-download'

import { getZip } from 'common/api'
import useScid from 'common/use-scid'
import useSnackbar from 'common/use-snackbar'
import { formatter } from 'common/date'

const DownloadDataFile = ({
  fileId,
  sentDate,
  onSuccess,
  downloaded,
}: {
  fileId: string
  sentDate: string
  onSuccess: () => void
  downloaded?: boolean
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const setErrorMessage = useSnackbar(
    'An error occurred while downloading the data file. Please try again later or contact support.',
  )
  const dateElem = formatter.format(sentDate)
  const scid = useScid()
  const download = useCallback(() => {
    if (!isLoading) {
      setIsLoading(true)
      getZip(`/api/colleges/${scid}/data-file/${fileId}/download`)
        .then((fileBlob) => {
          fileDownload(fileBlob, `scoir-data-file-${sentDate}.zip`, 'application/zip')
        })
        .then(() => onSuccess())
        .catch(() => {
          setErrorMessage()
        })
        .finally(() => setIsLoading(false))
    }
  }, [fileId, isLoading, sentDate, onSuccess, scid, setErrorMessage])
  return (
    <Button
      size="small"
      color="primary"
      variant={downloaded ? 'outlined' : 'contained'}
      disabled={isLoading}
      onClick={() => download()}
      aria-label={`Download data file for ${dateElem}`}
    >
      Data File
    </Button>
  )
}
DownloadDataFile.propTypes = {
  fileId: PropTypes.string.isRequired,
  sentDate: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
}
export default DownloadDataFile
